/**
 * Based on the provided view size width, determine the spacing factor for y-axes
 * in plotly-graphs.
 *
 * @param viewSize The size of the view in which the graph is displayed.
 * @returns
 */
export function determineYAxesSpacingFactor(viewSize: { width: number }) {
  const width = viewSize.width;

  // by @GP: default value if we work with title 14px and with 6 character => 14*6 + 2.5px_margin = 86.5
  return 86.5 / width;
}
